import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { makeMuiStyles } from '@styles';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const strings = createStrings({
  ja: {
    error: 'エラーが発生しました。',
    notFound: 'お探しの内容は見つかりません。',
  },
});

const useStyles = makeMuiStyles((_, common) => ({
  container: {
    ...common.flexCenter,
    ...common.middleText,
    ...common.textError,
    height: 150,
  },
}));

export interface BaseQuery {
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  isFetching: boolean;
  isInitialLoading: boolean;
}

export interface QueryContainerProps {
  queries?: BaseQuery[];
  children: React.ReactNode | (() => React.ReactNode);
  renderError?: () => React.ReactNode;
  renderNotFound?: () => React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  isNotFound?: boolean;
  size?: string;
}

export const QueryContainer: React.FC<QueryContainerProps> = (props) => {
  const {
    queries = [],
    children,
    renderError,
    renderNotFound,
    className,
    style,
    isNotFound = false,
    size,
  } = props;

  const classes = useStyles();

  const isSuccessOrIdle = queries.every((q) => q.isSuccess || (!q.isFetching && !q.isError));
  const isLoading = queries.some((q) => q.isInitialLoading);
  const isFailed = queries.some((q) => q.isError);

  const renderChildren = () => {
    if (typeof children === 'function') return children();
    return children;
  };

  const containerClass = clsx(classes.container, className);

  return (
    <>
      {isSuccessOrIdle && !isNotFound && renderChildren()}
      {isFailed &&
        !isLoading &&
        (renderError?.() ?? (
          <div className={containerClass} style={style}>
            {strings.error}
          </div>
        ))}
      {isLoading && (
        <div className={containerClass} style={style}>
          <CircularProgress color="primary" size={size ?? '4rem'} />
        </div>
      )}
      {isNotFound &&
        (renderNotFound?.() ?? (
          <div className={containerClass} style={style}>
            {strings.notFound}
          </div>
        ))}
    </>
  );
};
